module.exports = __webpack_public_path__ + "static/media/ic_arrow-left-primary.75ea2814.svg";